import TextTitleLight from 'components/TextTitleLight'
import { View } from 'components/View'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import PropTypes from 'prop-types'
import React from 'react'

class PageRecommended extends React.Component {
  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.element).isRequired
  }

  render () {
    return (
      <View>
        <TextTitleLight>
          Recommended
        </TextTitleLight>
        <View
          style={{
            flexDirection: View.DIRECTION.ROW,
            overflowX: 'scroll',
            WebkitOverflowScrolling: 'touch',
            marginTop: STYLES_MARGIN.SMALL,
            paddingBottom: STYLES_MARGIN.SMALL
          }}
        >
          {this.props.children}
        </View>
      </View>
    )
  }
}

export default PageRecommended
